import { getSelectPropValues } from '@eventbrite/eds-select';
import { unformat } from '@eventbrite/intl';
import range from 'lodash/range';
import { TicketStatus } from '../../models/tickets';

export const getSelectValues = (
    max: number,
    min: number,
    includeZero?: boolean,
) => {
    const values = range(min, max + 1);

    if (includeZero && min > 0) {
        values.unshift(0);
    }

    return getSelectPropValues(values);
};

export const getDonationChangeActionPayload = (
    ticketId: string,
    amount: string,
    currencyFormat?: string | null,
    variantId?: string,
) => {
    const basePayload = {
        id: ticketId,
        amount: unformat(amount, currencyFormat) as number,
    };

    return variantId
        ? {
              ...basePayload,
              variantId,
          }
        : basePayload;
};

const IS_CARD_DISABLED_BY_STATUS: Record<TicketStatus, boolean> = {
    [TicketStatus.onSale]: false,
    [TicketStatus.salesEndSoon]: false,
    [TicketStatus.salesEnded]: true,
    [TicketStatus.salesNotStarted]: true,
    [TicketStatus.salesStartAfter]: true,
    [TicketStatus.salesStartSoon]: true,
    [TicketStatus.soldOut]: true,
    [TicketStatus.unavailable]: true,
};

export const getIsCardDisabledByStatus = (status: TicketStatus) =>
    IS_CARD_DISABLED_BY_STATUS[status];
